import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Input, Inject } from '@angular/core';
import { ActivatedRoute, ParamMap , Router } from '@angular/router';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { TableEditBase } from '../../../_infrastructure/TableEdit/TableEditBase';
import { DocumentationComponent } from './documentation.component';
import { isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import { DocumentVMExtension } from './IDocumentation';
import { ControlContainer, NgForm } from '@angular/forms';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import { DocumentsHandlerService } from '../../../_infrastructure/Documents/DocumentHandlerService';
import { AlertService } from '../../../_infrastructure/Alerts/alert.service';
import { LoadingMaskService } from '../../../_infrastructure/LoadingMask/LoadingMaskService';
import { SubscriberInformationService } from '../../../_infrastructure/SubscriberInfo/SubscriberInformationService';
//import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import * as pdfjsLib from 'pdfjs-dist/build/pdf.mjs';
import { TranslateService } from '@ngx-translate/core';
import { PreStageDocumentationComponent } from '../../../workflow-instance-creator/documentation/prestage-documentation.component';
import { Subscription } from 'rxjs';
import { CommonDataService } from '../../../_infrastructure/CommonData/CommonDataService';
import { UtilsService } from '../../../_infrastructure/Utils/UtilsService';
//import { PromiseTry } from 'promise.try';
@Component({
    selector: 'documentation-table-edit',
    templateUrl: './documentation-table-edit.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class DocumentationTableEditComponent extends TableEditBase<DocumentVMExtension> implements OnInit, OnDestroy {

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.fileTypes)
  public fileTypes: models.DimensionVM[];
  @CommonData(DomainCodes.documentDesignationType)
  public designationTypes: models.DimensionVM[];

  @Input() public isMandatoryDocumentation : boolean;
  @Input() public isWorkflowOnSubscriber : boolean;
  @Input() public isReadonly: boolean = false;
  @Input() public isIncapacity: boolean = false;
  @Input() public isWorkflowMandatory: boolean = false;
  @Input() public workflowInstanceId: number;
  @Input() public role: string;
  public uploadedFile: File;
  public subscriber: models.SubscriberInformationVM;
  public invalidFileFormat: boolean = false;
  public invalidFileSize: boolean = false;
  public invalidExceedsFileSize: boolean = false;
  public invalidPDFFile: boolean = false;


  private MAX_FILE_SIZE: number = 8388608;
  private mainSubscription: Subscription = new Subscription(); 

  constructor(@Inject(DocumentationComponent) private parent: Component, private modalService: ModalService,
    private documentService: DocumentsHandlerService, private alertService: AlertService,
      private activeRoute: ActivatedRoute, private loadingMaskService: LoadingMaskService, private router: Router,
    private subscriberInfoService: SubscriberInformationService, private http: HttpClient, private translateService: TranslateService,
    private commonDataService: CommonDataService, private utilsService: UtilsService) {
    super(parent, modalService);
    
    this.subscriberInfoService.getCurrentSubscriber().subscribe((subscriber) => {
      this.subscriber = subscriber;
    });

    // resolve CommonData as of angular version 18 is broken
    const domainCodes: string[] = [
      DomainCodes.domains,
      DomainCodes.fileTypes,
      DomainCodes.documentDesignationType
    ];
    this.mainSubscription.add(
      this.commonDataService.getDomains(domainCodes).subscribe(results => {
        this.domains = this.utilsService.getDomainOfDomains(DomainCodes.domains, results).dimensions;
        this.fileTypes = this.utilsService.getDomainOfDomains(DomainCodes.fileTypes, results).dimensions;
        this.designationTypes = this.utilsService.getDomainOfDomains(DomainCodes.documentDesignationType, results).dimensions;
      })
    ); 

  }

  ngOnInit(): void {
    super.ngOnInit();
    this.uploadedFile = null;
  }

  ngOnDestroy(): void {
    if (this.mainSubscription) {
      this.mainSubscription.unsubscribe();
    }
  }

  isVersion2() {
    let result = false;
    if (this.parent['parentWorkflow']?.['workflowVersion']?.toString() === '2') {
      result = true;
    }
    return result;
  }

  onFileSelected(event: any) {
    this.setFile(event.target.files[0]);
  }

  onFileDropped(file: File) {
    this.setFile(file);
  }

  private async setFile(file: File) {
    this.invalidFileFormat = false;
    this.invalidFileSize = false;
    this.invalidPDFFile = false;

    if (!this.validatePDFFile(file)) {
      this.invalidFileFormat = true;
      return;
    } else if (this.validatePDFExceedsFileSize(file)) {
      this.invalidExceedsFileSize = true;
      return;
    } else {
      let fileCheck = await this.checkIfFileIsEmpty(file);
      if (fileCheck === "EmptyPDF") {
        this.invalidFileSize = true;
        return;
      } else if (fileCheck === "InvalidPDF") {
        this.invalidPDFFile = true;
        return;
      }
    }

    this.uploadedFile = file;
    this.item.fileName = this.uploadedFile.name;
    this.item.fileSizeKB = Math.round(this.uploadedFile.size / 1024);
    this.item.file = this.uploadedFile;
    if (!this.item.filePath) {
      this.item.filePath = this.uploadedFile.name;
    }
    
  }

  private validatePDFExceedsFileSize(file: File) {
    return file.size > this.MAX_FILE_SIZE;
  }

  private validatePDFFile(file: File) {
    return file.type === 'application/pdf';
  }

  private async checkIfFileIsEmpty(file: File):Promise<string>  {
    pdfjsLib.GlobalWorkerOptions.workerSrc = "pdf.worker.mjs";
;
    var fileReader = new FileReader();
    if (file.type === 'application/pdf') {
      fileReader.readAsArrayBuffer(file);

      return new Promise(function (resolve, reject) {
        fileReader.onloadend = async function (ev) {
          let base64Data = fileReader.result as ArrayBuffer;
          const countPromises = [];

          if (base64Data.byteLength != 0) {
            //Códigos dos possíveis objetos de imagens presentes em ficheiros PDF
            var pdfImgObjCodes = [74, 75, 83, 84, 89, 85, 88, 86, 87, 82, 90, 66];

            let pdfProcessing: Int8Array = new Int8Array(base64Data as ArrayBuffer);
            const pdf = await pdfjsLib.getDocument(pdfProcessing);
            try {
              for (let i = 1; i <= (await pdf.promise).numPages; i++) {
                const page = await (await pdf.promise).getPage(i);

                //Verificar se o ficheiro PDF contém conteúdo de texto
                const textContent = await page.getTextContent();
                countPromises.push(textContent.items.map((s: any) => s.str).join(''));

                //Verificar se o ficheiro PDF contém conteúdo de imagens
                const imgContent = await page.getOperatorList();
                imgContent.fnArray.map(q => {
                  if (pdfImgObjCodes.includes(q))
                    countPromises.push('Img');
                });
              }
            } catch (e) {
              resolve("InvalidPDF");
            }
          } else {
            resolve("EmptyPDF");
          }

          await Promise.all(countPromises).then(function (e) {
            let pdfContent = e.join('');

            if (pdfContent !== ' ') {
              resolve("ValidPDF");
            } else {
              resolve("EmptyPDF");
            }
          })
        }
      })

    }
  }

  emitListChange(isEdit : boolean): void {
    if (isEdit)
      this.itemList.splice(this.editIndex, 1, this.item);
    else
      this.itemList.push(this.item);

    this.listChanged.emit(this.itemList);
  }

  onEdit(isEdit: boolean) {
    //Necessário setar o touched em todos os inputs no seguinte de forma a que as mensagens de erro apareçam
    super.markTouched();

    if (!super.checkValid())
      return;

    //If a file was uploaded
    if (!isNullOrUndefined(this.uploadedFile)) {
      this.http.get('api/Workflow/ValidateInstance', { params: { workflowInstanceID: this.parent['parentWorkflow']?.['workflowInstanceId'], role: this.parent['parentWorkflow']['workflowInstance']['instanceRole']} })
        .subscribe((res: any) => {
          // RES é o resultado que vem do BE, decisão para continuar ou não
          if (res.message == 'OK') {
            this.loadingMaskService.setShowLoading(true, false);
            this.documentService.UploadFile(this.uploadedFile, this.workflowInstanceId.toString(), this.subscriber.numUtente, this.item.designationTypeCode).subscribe(result => {
              this.loadingMaskService.setShowLoading(false);
              if (result.stateCode == "OK") {
                this.item.fileID = result.fileID.toString();
                if (!isEdit) this.item.isMandatoryFile = false;
                this.emitListChange(isEdit);
              }
              else {
                this.alertService.error(result.message);
              }
            }, error => this.loadingMaskService.setShowLoading(false));
          } else {
            this.alertService.error(res.message);
          }
        });

      
    }
    else {
      this.emitListChange(isEdit);
    }
  }

/*  onRemove_old(isEdit: boolean) {

    var listToAlter = [...this.itemList];
    if (this.isEdit && this.item.isMandatoryFile.toString()!='true'){
      listToAlter.splice(this.editIndex, 1);
      this.listChanged.emit(listToAlter);
    }

    this.listChanged.emit(listToAlter);
  }//*/

  onRemove(isEdit: boolean) {

    this.http.get<models.WorkflowStatusVM[]>('api/Workflow/ValidaDisponibilidadePGPCall', {}).subscribe((result: any) => {
      // PIT 40802 \\
      if (result.stateCode == 'I') {
        this.router.navigate(['validatepgponline']);
        return;
      } else {
          var listToAlter = [...this.itemList];

          if (this.isEdit) {
            if (this.item.isMandatoryFile.toString() != 'true') {
              listToAlter.splice(this.editIndex, 1);
              this.listChanged.emit(listToAlter);
            } else {
              this.onClearFile(this.isEdit);
            }

          }

          /*    if (this.isEdit && this.item.isMandatoryFile.toString() != 'true') {
                listToAlter.splice(this.editIndex, 1);
                this.listChanged.emit(listToAlter);
              }//*/

          this.listChanged.emit(listToAlter);
      }
    },
      error => this.loadingMaskService.setShowLoading(false)
    );
  }



  downloadDocument() {
    if (!isNullOrUndefined(this.item.fileID) && this.item.fileID != "")
      this.documentService.DownloadFile(this.item.fileID, this.item.fileName, this.workflowInstanceId.toString(), this.subscriber.subscriberNumber);
  }

clearItem(itm: DocumentVMExtension) {
    itm.fileName = '';
    itm.file = null;
    itm.fileID = null;
    itm.name = "";
    itm.observation = "";
    itm.filePath = "";
}

  onClearFile(isEdit: boolean, emit: boolean = false) {
    this.http.get<models.WorkflowStatusVM[]>('api/Workflow/ValidaDisponibilidadePGPCall', {}).subscribe((result: any) => {

      if (result.stateCode == 'I') {
        this.router.navigate(['validatepgponline']);
        return;
      } else {
        this.uploadedFile = null;


        this.clearItem(this.item);
        //this.item.fileName = '';
        //this.item.file = null;
        //this.item.fileID = null;
        //this.item.name = "";
        //this.item.observation = "";
        //this.item.filePath = "";

        if ((this.editIndex !== null) && !isNaN(this.editIndex)) {
          this.clearItem(this.itemList[this.editIndex]);
          //this.itemList[this.editIndex].fileName = '';
          //this.itemList[this.editIndex].file = null;
          //this.itemList[this.editIndex].fileID = null;  // -----<<<<
          //this.itemList[this.editIndex].name = "";
          //this.itemList[this.editIndex].observation = "";
        }//*/

        if (emit) {
          this.listChanged.emit(this.itemList);
        }

        return false;
      }
    },
      error => this.loadingMaskService.setShowLoading(false)
    );
  }


  public removeDisabled(): boolean {
    if (!this.isEdit) return false;

//    if (!this.isMandatoryDocumentation) return false;
    //return this.isMandatoryDocumentation && (this.item.isMandatoryFile.toString().toLowerCase() == 'true');

    if (!this.isMandatoryDocumentation) return false;

    return (this.item.isMandatoryFile.toString().toLowerCase() == 'true');

  }//*/


  /*
  public removeDisabled(): boolean {
    if (!this.isEdit) return false;

    if (!this.isMandatoryDocumentation) return false;

    return (this.item.isMandatoryFile.toString().toLowerCase() == 'true');

  }//*/

  shouldEditName(code: string) {
    return code == 'ECL000' || code == 'MDP130' || code == 'MPO000';
  }

  sortDesignationType(a, b) {
    if (b.code == 'MDP130')
      return -1;
    if (a.code == 'MDP130')
      return 1;
    return a.description - b.description;
  }

  getFilteredDesignationTypes() {
    /*var filteredList = this.designationTypes;

    if (this.isReadonly) return filteredList.sort(this.sortDesignationType);

    if (!this.isWorkflowMandatory) {
      filteredList = filteredList.filter(x => x.code != 'DPE051');
    }

    // Allways remove 'ECL016 - Questionario médico'
    filteredList = filteredList.filter(x => x.code != 'ECL016');

    if (this.isWorkflowOnSubscriber) {
      filteredList = filteredList.filter(x => x.code != 'MDP170');
    }

    return filteredList.sort(this.sortDesignationType);*/
    /*for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
      if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === 'dropListDocuments') {
        result.push(this.parentWorkflow.workflowDropdowns.options[i]);
      }
    }*/
    if (this.isVersion2()) {
      let result = [];
      for (let i = 0; i < this.parent['workflowDropdowns'].options.length; i++) {
        if (this.parent['workflowDropdowns'].options[i]['dropdown'] === 'dropListDocuments') {
          if (!this.isWorkflowMandatory) {
            if (this.isWorkflowOnSubscriber) {
              if (this.parent['workflowDropdowns'].options[i]['type'] === '002')
                result.push(this.parent['workflowDropdowns'].options[i]);
            } else {
              if (this.parent['workflowDropdowns'].options[i]['type'] === '001')
                result.push(this.parent['workflowDropdowns'].options[i]);
            }
          } else {
            if (this.parent['workflowDropdowns'].options[i]['type'] === '001' || this.parent['workflowDropdowns'].options[i]['type'] === '002')
              result.push(this.parent['workflowDropdowns'].options[i]);
          }
        }
      }
      return result;
    } else {
      var filteredList = this.designationTypes;

      if (this.isReadonly) return filteredList.sort(this.sortDesignationType);

      if (!this.isWorkflowMandatory) {
        filteredList = filteredList.filter(x => x.code != 'DPE051');
      }

      // Allways remove 'ECL016 - Questionario médico'
      filteredList = filteredList.filter(x => x.code != 'ECL016');

      if (this.isWorkflowOnSubscriber) {
        filteredList = filteredList.filter(x => x.code != 'MDP170');
      }

      return filteredList.sort(this.sortDesignationType);
    }

  }

  docDesignationChanged() {
    var dropdown = this.getFilteredDesignationTypes();
    
    for (let i = 0; i < dropdown.length; i++) {
      if (dropdown[i].value === this.item.designationTypeCode) {
        this.item.description = dropdown[i].description;
      }
    }

    this.item.name = null;
  }

}


